'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function TrailingSlashFix() {
  const router = useRouter()

  useEffect(() => {
    const { pathname, search } = window.location
    if (pathname !== '/' && pathname.endsWith('/')) {
      // Remove trailing slash
      router.replace(pathname.slice(0, -1) + search)
    }
  }, [])

  return null
}
